import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import './css/index.scss';
import {
	CCard, CCol, CRow, CCardHeader,
	CCardTitle, CCardBody, CImage,
} from 'compat/coreui';
import { IMAGE_URL } from '../Constants/constants';
import { CHAIN } from '../chain/config';

export default function Homepage() {
	const navigate = useNavigate()
	const user = useSelector(state => state.user)
	const [pin, setPin] = useState('');
	const [sellerData, setSellerData] = useState([]);
	const [reviewData, setReviewData] = useState([]);
	const [blockNumber, setBlockNumber] = useState(null);

	const searchHandler = (e) => {
		e.preventDefault();
		navigate("/virginia", { state: { sr: pin } })
	}
	const searchHandlerRedirect = (e, search) => {
		e.preventDefault()
		navigate("/search", { state: { pincode: pin, sr: search } })
	}

	useEffect(() => {
		getBusiness();
		// live chain heartbeat — polls BRDPoSChain head block
		let cancelled = false;
		const tick = () => {
			fetch(CHAIN.rpcUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ jsonrpc: '2.0', id: 1, method: 'eth_blockNumber', params: [] }),
			}).then(r => r.json()).then(j => {
				if (!cancelled && j.result) setBlockNumber(parseInt(j.result, 16));
			}).catch(() => {});
		};
		tick();
		const iv = setInterval(tick, 5000);
		return () => { cancelled = true; clearInterval(iv); };
	}, [])

	const getBusiness = () => {
		axios.get(`${process.env.REACT_APP_APP_API_URL}/api/sellers`, {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('token')
			},
			params: { pincode: "", sr: "" }
		}).then(res => {
			if (res.data.status === 200) {
				setSellerData(res.data.sellers)
				setReviewData(res.data.reviews)
			}
		}).catch(() => {})
	}

	return (

		<React.Fragment>

			<div className="banner-video bp-hero bp-cine-hero">
				<span className="bp-ghost" aria-hidden="true">PLUG</span>
				<div className="bp-cine">
					<span className="bp-cine-label">B&nbsp;I&nbsp;R&nbsp;R&nbsp;P&nbsp;L&nbsp;U&nbsp;G</span>
					<h1 className="bp-cine-line">SHOP&nbsp;&nbsp;·&nbsp;&nbsp;PAY&nbsp;&nbsp;·&nbsp;&nbsp;TRACK&nbsp;&nbsp;·&nbsp;&nbsp;SELL</h1>
					<div className="bp-cine-statement">ONE MARKETPLACE.</div>
					<button
						className="bp-enter"
						onClick={() => {
							const el = document.querySelector('.suggested-container');
							if (el) el.scrollIntoView({ behavior: 'smooth' });
						}}>
						E N T E R
					</button>
					<span className="bp-cine-foot">
						every order settled on {CHAIN.name.toLowerCase()}
						{blockNumber ? <> &nbsp;·&nbsp; <em className="jp-live-dot" /> block #{blockNumber.toLocaleString()}</> : null}
					</span>
				</div>
				<div className="jp-scroll-hint" aria-hidden="true"><span /></div>
			</div>

			<div className="suggested-container " >
				<div className="container">
					<div className="bp-sec-head">
						<span className="bp-sec-label">MARKETPLACE</span>
						<h2 className="bp-sec-title">Explore</h2>
					</div>
					<form className="bp-mega-search" onSubmit={searchHandler} role="search">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
						<input type="text" placeholder="Search products, shops, brands, or your city…" onChange={(e) => setPin(e.target.value)} aria-label="Search the marketplace" />
						<button type="submit" className="bp-btn-primary">Search</button>
					</form>
					<div className="bp-mega-hints">
						<span className="bp-dim">Popular:</span>
						{['Electronics', 'Fashion', 'Grocery', 'Coffee'].map(hint => (
							<button key={hint} className="bp-hint-chip" onClick={e => searchHandlerRedirect(e, hint)}>{hint}</button>
						))}
					</div>

					<div className="bp-cat-row">
						<button className="bp-cat-card c-products" onClick={e => searchHandlerRedirect(e, '')}>
							<span className="bp-cat-icon" aria-hidden="true">🛍️</span>
							<span className="bp-cat-info"><strong>Products</strong><small>Browse the full catalog</small></span>
							<span className="bp-cat-arrow" aria-hidden="true">→</span>
						</button>
						<button className="bp-cat-card c-deals" onClick={e => searchHandlerRedirect(e, 'Deals')}>
							<span className="bp-cat-icon" aria-hidden="true">🏷️</span>
							<span className="bp-cat-info"><strong>Deals</strong><small>Today's best offers</small></span>
							<span className="bp-cat-arrow" aria-hidden="true">→</span>
						</button>
						<button className="bp-cat-card c-shops" onClick={e => searchHandlerRedirect(e, '')}>
							<span className="bp-cat-icon" aria-hidden="true">🏬</span>
							<span className="bp-cat-info"><strong>Shops</strong><small>Sellers near you</small></span>
							<span className="bp-cat-arrow" aria-hidden="true">→</span>
						</button>
						<button className="bp-cat-card c-delivery" onClick={e => searchHandlerRedirect(e, 'Deliveries')}>
							<span className="bp-cat-icon" aria-hidden="true">🚚</span>
							<span className="bp-cat-info"><strong>Delivery</strong><small>Straight to your door</small></span>
							<span className="bp-cat-arrow" aria-hidden="true">→</span>
						</button>
					</div>
				</div>
			</div>

			<div className="main_cta_slide">
				<div className="wrapper">
					<div className="heading">every order settled on {CHAIN.name} —<br /> transparent, instant, yours</div>
				</div>
			</div>

			{sellerData.length > 0 && <section className="bp-shops-sec">
				<div className="bp-sec-head" style={{ textAlign: 'center' }}>
					<span className="bp-sec-label">FEATURED</span>
					<h2 className="bp-sec-title">Shops on BirrPlug</h2>
				</div>
				<div className="bp-shops-grid">
					{sellerData.map((item) => (
						<Link to={"/businessnew/" + item._id} className="bp-shop-card" key={item._id}>
							<div className="bp-shop-cover">
								<img alt="" src={item.coverImage ? IMAGE_URL + item.coverImage : "/images/placeholder.svg"} />
							</div>
							<div className="bp-shop-avatar">
								<img alt="" src={item.image ? IMAGE_URL + item.image : "/images/placeholder.svg"} />
							</div>
							<div className="bp-shop-body">
								<h4>{item.businessName}</h4>
								<span className="bp-shop-chip">{item.businessType}</span>
								{item.city && <span className="bp-shop-city">📍 {item.city}</span>}
								<span className="bp-shop-visit">Visit shop <i>→</i></span>
							</div>
						</Link>
					))}
				</div>
			</section>}

			<div className="black-bg jp-how">
				<div className="bp-sec-head" style={{ textAlign: 'center' }}>
					<span className="bp-sec-label">PROTOCOL</span>
					<h2 className="bp-sec-title">How BirrPlug Works</h2>
				</div>
				<div className="container">
					<div className="jp-how-grid">
						<div className="jp-how-card">
							<span className="jp-how-ghost" aria-hidden="true">01</span>
							<span className="jp-how-icon" aria-hidden="true">🛒</span>
							<span className="jp-how-step">STEP 01</span>
							<h4>Browse & Add to Cart</h4>
							<p>Discover local shops and products, compare deals, and build your cart — no account gymnastics, no friction.</p>
						</div>
						<div className="jp-how-card">
							<span className="jp-how-ghost" aria-hidden="true">02</span>
							<span className="jp-how-icon" aria-hidden="true">⚡</span>
							<span className="jp-how-step">STEP 02</span>
							<h4>Pay in BRC</h4>
							<p>Connect BirrWallet or MetaMask and settle in seconds on {CHAIN.name}. Prefer cash? Pay on delivery instead.</p>
						</div>
						<div className="jp-how-card">
							<span className="jp-how-ghost" aria-hidden="true">03</span>
							<span className="jp-how-icon" aria-hidden="true">⛓️</span>
							<span className="jp-how-step">STEP 03</span>
							<h4>Verified On-Chain</h4>
							<p>Every payment is verified against the blockchain and linked to your order — a receipt no one can fake or lose.</p>
						</div>
						<div className="jp-how-card">
							<span className="jp-how-ghost" aria-hidden="true">04</span>
							<span className="jp-how-icon" aria-hidden="true">📦</span>
							<span className="jp-how-step">STEP 04</span>
							<h4>Track to Your Door</h4>
							<p>Follow your order from accepted to on-the-way to delivered, with the seller updating status in real time.</p>
						</div>
					</div>
				</div>
			</div>

			{(!(user.email || user.walletAddress || user._id)) && <section className="bp-join-home">
				<div className="bp-sec-head" style={{ textAlign: 'center' }}>
					<span className="bp-sec-label">JOIN</span>
					<h2 className="bp-sec-title">New to <span className="jp-gradient-text">BirrPlug</span>?</h2>
					<p className="bp-join-lede">The commerce layer of the Birr ecosystem — payments settle on {CHAIN.name}, reputation is earned in the open, and your wallet is your account. Join as a shopper in seconds, or open your shop and start selling.</p>
				</div>

				<div className="bp-join-home-grid">
					<div className="bp-join-feats">
						<div className="bp-feat">
							<span className="bp-feat-icon" aria-hidden="true">💳</span>
							<h4>Pay your way</h4>
							<p>BRC straight from your wallet — or cash on delivery when you prefer.</p>
						</div>
						<div className="bp-feat">
							<span className="bp-feat-icon" aria-hidden="true">⛓️</span>
							<h4>Receipts on-chain</h4>
							<p>Every payment is independently verifiable on the public explorer.</p>
						</div>
						<div className="bp-feat">
							<span className="bp-feat-icon" aria-hidden="true">⭐</span>
							<h4>Real reputation</h4>
							<p>Reviews from real buyers — trust that can't be bought.</p>
						</div>
						<div className="bp-feat">
							<span className="bp-feat-icon" aria-hidden="true">📊</span>
							<h4>Seller cockpit</h4>
							<p>Products, deals, orders, and analytics in one dashboard.</p>
						</div>
					</div>

					<aside className="bp-join-ctabox">
						<h3>Get started</h3>
						<p className="bp-dim">No passwords, no forms — connect your wallet and you're in.</p>
						<Link to="/signup" className="bp-btn-primary">Create Account</Link>
						<Link to="/login" className="bp-btn-ghost">Sign In</Link>
						<div className="bp-join-divider"><span>want to sell?</span></div>
						<Link to="/join/business" className="bp-join-selllink">Open your shop →</Link>
					</aside>
				</div>
			</section>}

			<section className="bp-getwallet">
				<div className="bp-getwallet-inner">
					<div className="bp-phone-wrap" aria-hidden="true">
						<div className="bp-phone-mock v2">
							<div className="bp-phone-notch" />
							<div className="bp-phone-screen">
								<div className="bp-ph-status"><span>9:41</span><span className="bp-mono">⛓ 3669</span></div>
								<div className="bp-ph-bal">
									<span className="bp-ph-bal-label">TOTAL BALANCE</span>
									<strong>1,284<small>.56</small> <em>BRC</em></strong>
									<svg className="bp-ph-spark" viewBox="0 0 100 26" preserveAspectRatio="none">
										<polyline points="0,20 12,17 24,19 36,12 48,14 60,8 72,10 84,5 100,7" fill="none" stroke="rgba(0,20,30,0.55)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</div>
								<div className="bp-ph-actions">
									<span><i>↑</i>Send</span>
									<span><i>↓</i>Receive</span>
									<span><i>⇄</i>Swap</span>
									<span><i>🛍</i>Shop</span>
								</div>
								<div className="bp-ph-txs">
									<div className="bp-ph-tx"><i>🛍️</i><span><b>BirrPlug order</b><small>Demo Electronics</small></span><em className="neg">−45 BRC</em></div>
									<div className="bp-ph-tx"><i>⚡</i><span><b>Staking reward</b><small>NativeBRC pool</small></span><em className="pos">+2.4 BRC</em></div>
									<div className="bp-ph-tx"><i>📦</i><span><b>Order delivered</b><small>#4f2a…9c</small></span><em className="ok">✓</em></div>
								</div>
							</div>
						</div>
						<span className="bp-float f1">⚡ Instant settlement</span>
						<span className="bp-float f2">🔐 Self-custody</span>
						<span className="bp-float f3">⛓ On-chain receipts</span>
					</div>
					<div className="bp-getwallet-copy">
						<span className="bp-sec-label">WALLET</span>
						<h2 className="bp-sec-title">Get BirrWallet</h2>
						<p>One wallet for the whole Birr ecosystem.<br />Shop on BirrPlug, stake, swap, and hold your BRC.</p>
						<a href="https://birr.foundation/wallet" target="_blank" rel="noreferrer" className="bp-btn-primary">Download BirrWallet</a>
					</div>
				</div>
			</section>

			<div className="product-container homepage-seller-details m-auto">
				<CRow className="mt-3 mb-5">
					{reviewData.map((item, index) => {
						return (<CCol lg={4} sm={3} key={index}>
							<CCard className="review_card">
								<div className="review_text">
									<p>{item.msg}</p>
								</div>
								<div className="review_author">
									<CImage src={item.reviewed ? IMAGE_URL + item.reviewed.image : "/images/placeholder.svg"} />
									<div className="author"><a href="/">{item.reviewer ? item.reviewer.businessName : ""}</a> reviewed <a href="/">{item.reviewed ? item.reviewed.businessName : ""}</a></div>
									<div className="review_stars">
										<span className="bp-review-stars" aria-label={`${item.rating} star rating`}>
											{Array(item.rating || 0).fill(1).map((el, i) => <span key={i}>★</span>)}
										</span>
									</div>
								</div>
							</CCard>
						</CCol>
						)
					})}
				</CRow>
			</div>

		</React.Fragment>
	)
}
